import request from "@/utils/request";

// 获取换热站水系统运行平均数据
export function getOperationAvgData(data) {
  return request({
    url: `/green/equ/operation-record/operation-avg-data`,
    method: "post",
    data
  });
}
